<script setup>
import QuickResult from './QuickResult.vue';
import {computed, inject} from "vue";
import {useSearchStore} from "../store/useSearchStore";

const $bus = inject('$bus');
const store = useSearchStore();

const props = defineProps({
    results: {
        type: Array,
        default: null,
    },
    pageResults: {
        type: Array,
        default: null,
    },
    searchQuery: {
        type: String,
        default: null,
    },
    searchTyp: {
        type: String,
        default: null,
    },
    currentPage: {
        type: Number,
        default: null,
    },
    totalResults: {
        type: Number,
        default: null,
    },
    searchUrl: {
        type: String,
        default: null,
    },
    busy: Boolean,
    noSearch: Boolean,
    searchSuggestions: Boolean,
});

const results = computed(() => props.results);
const searchSuggestions = computed(() => props.searchSuggestions);
const searchQuery = computed(() => props.searchQuery);
const noSearch = computed(() => props.noSearch);

</script>
<template>
    <div class="category-results">
        <template v-for="(result, index) in results">
            <template v-if="((index < 2) || searchSuggestions) && results.length > 0">
                <QuickResult
                    :id="`search-result-${index +1}`"
                    :key="`search-result-${index + 1}`"
                    :data="result"

                    :index="index"
                    :allResults="results"
                    :search-query="searchQuery"
                    :noSearch="noSearch"
                    :search-url="searchUrl"
                />
            </template>
        </template>
    </div>
</template>
